import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { ApolloClientOptions } from '@apollo/client/core/ApolloClient';

const defaultSettings: ApolloClientOptions<unknown> = {
  cache: new InMemoryCache(),
  queryDeduplication: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  },
};

const nftClient = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_NFT_SUBGRAPH,
    credentials: 'same-origin',
  }),
});

const nftClientRinkeby = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_NFT_SUBGRAPH_RINKEBY,
    credentials: 'same-origin',
  }),
});

const nft1155Client = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_NFT_1155_SUBGRAPH,
    credentials: 'same-origin',
  }),
});

const nft1155ClientRinkeby = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_NFT_1155_SUBGRAPH_RINKEBY,
    credentials: 'same-origin',
  }),
});

export const getNFTClient = (networkId: number): ApolloClient<unknown> => {
  switch (networkId) {
    case 4:
      return nftClientRinkeby;
    default:
      return nftClient;
  }
};

export const getNFTClient1155 = (networkId: number): ApolloClient<unknown> => {
  switch (networkId) {
    case 4:
      return nft1155ClientRinkeby;
    default:
      return nft1155Client;
  }
};

// Non standard were never implemented
export const nonStandardNFTClient = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_NON_STANDARD_SUBGRAPH,
    credentials: 'same-origin',
  }),
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getNonStandardNFTClient = (networkId: number): ApolloClient<unknown> => {
  return nonStandardNFTClient;
};

export const kiwiClient = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_KIWI_GQL,
    credentials: 'same-origin',
  }),
});

export const kiwiClientRinkeby = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_KIWI_SUBGRAPH_RINKEBY,
    credentials: 'same-origin',
  }),
});

export const kiwiClientGoerli = new ApolloClient({
  ...defaultSettings,
  link: createHttpLink({
    uri: process.env.REACT_APP_KIWI_GQL_GOERLI,
    credentials: 'same-origin',
  }),
});

export const getKiwiClient = (networkId: number): ApolloClient<unknown> => {
  switch (networkId) {
    case 4:
      return kiwiClientRinkeby;
    case 5:
      return kiwiClientGoerli;
    default:
      return kiwiClient;
  }
};
